import {
  Box,
  TimeInput,
  formatDateTimeDisplay,
  parseDisplayDateInput,
} from '@servicepipe/ui-components';
import React, { useEffect, useRef, useState } from 'react';

const toDateOnlyDisplayValue = (date) => {
  const normalized = date instanceof Date ? date : new Date(date);

  return formatDateTimeDisplay(normalized, 'browser').split(' ')[0];
};

const isSameCalendarDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

const isCompleteDateInput = (value) => {
  const trimmed = value.trim();

  return Boolean(trimmed) && !trimmed.includes('_');
};

export const TrialPeriodDateInput = ({ value, onChange, disabled = false }) => {
  const containerRef = useRef(null);
  const valueRef = useRef(value);
  const draftRef = useRef(toDateOnlyDisplayValue(value));
  const [displayValue, setDisplayValue] = useState(() => toDateOnlyDisplayValue(value));

  useEffect(() => {
    valueRef.current = value;
    const formatted = toDateOnlyDisplayValue(value);
    draftRef.current = formatted;
    setDisplayValue(formatted);
  }, [value]);

  const revertToPreviousValue = () => {
    const previous = toDateOnlyDisplayValue(valueRef.current);
    draftRef.current = previous;
    setDisplayValue(previous);
  };

  const commitOrRevert = () => {
    const next = draftRef.current.trim();

    if (!isCompleteDateInput(next)) {
      revertToPreviousValue();
      return;
    }

    const parsed = parseDisplayDateInput(next);

    if (!parsed) {
      revertToPreviousValue();
      return;
    }

    if (isSameCalendarDay(parsed, valueRef.current)) {
      revertToPreviousValue();
      return;
    }

    onChange(parsed);
  };

  return (
    <Box ref={containerRef} width="100%">
      <TimeInput
        timezone="browser"
        isShowTime={false}
        disabled={disabled}
        value={displayValue}
        placeholder="DD/MM/YY"
        onChange={(nextValue) => {
          draftRef.current = nextValue;
          setDisplayValue(nextValue);

          requestAnimationFrame(() => {
            if (!containerRef.current?.contains(document.activeElement)) {
              commitOrRevert();
            }
          });
        }}
        onBlur={commitOrRevert}
      />
    </Box>
  );
};
